import SiCommand from '@/icons/SiCommand';
import SiGaming from '@/icons/SiGaming';
import SiHardDriveStorage from '@/icons/SiHardDriveStorage';
import SiInformation from '@/icons/SiInformation';
import SiMicrochip from '@/icons/SiMicrochip';
import SiMonitor from '@/icons/SiMonitor';
import { ReactNode } from 'react';

const icons: Record<string, ReactNode> = {
  screen: <SiMonitor />,
  cpu: <SiMicrochip />,
  gpu: <SiGaming />,
  storage: <SiHardDriveStorage />,
  os: <SiCommand />
};

// This is a slightly odd pattern in that we're using a Proxy to provide
// custom logic on how to handle icons that aren't found in the icons object
// or use a different name. Here we're able to transparently handle the
// different names for the same icon without having to define multiple entries.
export const SpecIcons = new Proxy(icons, {
  get: function (target, name) {
    if (typeof name === 'symbol') throw new Error('Symbol not supported');
    const id = name.toLowerCase();
    const icon = target[id];
    // If we have an icon, return it
    if (icon) return icon;

    // Otherwise, try to find an icon that matches the name
    switch (id) {
      case 'chip':
        return <SiMicrochip />;
      case 'gaming':
        return <SiGaming />;
      case 'command':
        return <SiCommand />;
      default:
        return <SiInformation />;
    }
  }
});
